
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Alert, Pagination, Form, Button, ButtonToolbar } from 'react-bootstrap'
import { tableHelper, momentHelper } from './helpers'
import SelectDate from '../../component/element/SelectDate'
import SelectObject from '../../component/element/SelectObject'
import PrintButtons from '../../component/element/PrintButtons'
import './report.css'
import Notice from './Notice'
import DatePicker from '../../component/element/DatePicker'
import FontAwesome from 'react-fontawesome';
import IframeModal from '../../component/element/IframeModal'
import ReportStore from '../../stores/ReportStore'

class ReportKKCBillingNoteReceivable extends Component {
  constructor(...args) {
    super(...args)
    const WHOLE_YEAR = '00'
    this.state = {
      toggleNotice: false,
      month: WHOLE_YEAR,
      year: momentHelper.getYear(),
      dataList: []
    }
  }

  onPrintClick() {
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportKKCBillingNoteReceivable&year='+this.state.year+'&month='+this.state.month
    } else{
      url = './pdf/v2?startPage=PrintReportKKCBillingNoteReceivable&year='+this.state.year+'&month='+this.state.month
    }
    this.refs.iframe.loadUrl(url)
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month)
    }
  }

  loadData(year,month){
    
    ReportStore.loadReportBillingnoteReceivable(year,month,(result)=>{

        this.setState({dataList:result.data})
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderRowData(dataList){
    if(dataList.length===0){
      return (<tr><td colSpan={12}>ไม่พบข้อมูล</td></tr>)
    }
    return dataList.map((item,index)=>(
      <tr key={index}>
        <td className='text-center'>{item.bill_date}</td>
        <td className='text-center'>{item.claim_no}</td>
        <td>{item.customer_name}</td>
        <td className='text-center'>{item.car_registration_no}</td>
        <td className='text-center'>{item.bill_no}</td>
        <td className='text-right'>{this.getNumberFormat(item.amount)}</td>                  
        <td className='text-center'>{item.work_no}</td>
        <td className='text-right'>-</td>
        <td className='text-right'>-</td>
        <td className='text-center'></td>
        <td className='text-center'></td>
        <td className='text-center'></td>
      </tr>
    ))
  }

  renderTable() {
    let {dataList} = this.state
    return (
      <div className='display-overflow'>
        <table className='table table-responsive table-hover table-bordered-solid table-report-kkc-billing-note-receivable' style={{width:'1700px'}}>
          <thead>
            <tr>
              <th rowSpan={2} className='text-center bg-none' style={{width:'120px'}}>ว/ด/ป วางบิล</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>เลขที่เคลม</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'200px'}}>บริษัท</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'220px'}}>ทะเบียนรถ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>เลขที่ใบแจ้งหนี้</th>
              <th rowSpan={2} className='text-center bg-none'>จำนวนเงิน</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>ลำดับเอกสาร</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงิน<br/>ที่จะได้รับ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>ค้างรับ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'120px'}}>ว/ด/ป</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>เลขที่<br/>หัก ณ ที่จ่าย</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>ใบกำกับ<br/>ภาษีเลขที่</th>
            </tr>            
          </thead>
          <tbody>
            {
              this.renderRowData(dataList)                            
            }           
          </tbody>  
        </table>
      </div>
    )
  }

  onSaveClick(e) {
    this.setState((prevState) => ({
      toggleNotice: !prevState.toggleNotice
    }))
  }

  onMonthChange(val) {
    this.setState({
      month: val.value
    })
    this.loadData(this.state.year,val.value)
  }

  onYearChange(val) {
    this.setState({
      year: val.value
    })
    this.loadData(val.value,this.state.month)
  }

  renderToolbar() {
    return (
      <Form inline>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
          />
      </Form>
    )
  }

  onDateChange(dateString, dateMoment) {
    // console.log('onDateChange')
    // console.log(dateString, dateMoment)
  }

  renderSaveButton() {
    return (
      <Button
        onClick={this.onSaveClick.bind(this)}
      >
        บันทึกข้อมูล
      </Button>
    )
  }

  renderDatePicker(dateValue) {
    return (
      <DatePicker style={{ display: 'inline-block' }}
        ref={(ele) => { this.datePicker = ele }}
        showIcon={true}
        showFooter={true}
        buddhistEra
        value={dateValue}
        onChange={this.onDateChange.bind(this)}
      />
    )
  }

  render() {
    const titile = 'รายงานสรุปยอดใบวางบิลค้างรับ'
    let {toggleNotice} = this.state
    return(
        <Box>
          <Box.Header border={true}>
            <Box.Title>{this.props.renderMenu()}</Box.Title>
            <Box.Tools>
              <Button                 
                bsStyle={'link'} className='bg-maroon'
                onClick={this.onPrintClick.bind(this)}
              >
                <FontAwesome name='print'/>&nbsp;พิมพ์เอกสาร
              </Button>                           
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            {this.renderToolbar()}
            {this.renderTable()}
            <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
          </Box.Body>
        </Box>
    )
  }
}

ReportKKCBillingNoteReceivable.defaultProps = {
  show : false
}

export default ReportKKCBillingNoteReceivable;





// WEBPACK FOOTER //
// ./src/view/report/ReportKKCBillingNoteReceivable.js